<template>
  <div>
    <b-card>
      <!-- <swiper class="swiper" :options="swiperOptions"> -->
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide v-for="(item, index) in cards" :key="('item-', +index)"> -->
      <!-- <div
            class="gray-card cursor-pointer"
            @click="handleclick(item.route)"
          > -->
      <!-- <b-card
              :title="item.title"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            > -->
      <!-- <b-card-text class="fsize21px"
                ><b>{{ item.text }}</b>
                <b-button
                  class="btn-p20 ml-10"
                  v-if="item.id === '04'"
                  variant="primary"
                  >withdraw</b-button
                >
              </b-card-text> -->
      <!-- </b-card> -->
      <!-- </div> -->
      <!-- </swiper-slide> -->
      <!-- </swiper> -->
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(volunteerTable)"
          >
            <b-card
              title="Upcoming Session"
              style="max-width: 40rem"
              class="mb-2 bg-f8f9fa fsize21px shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_allbookingcounts.upcommingSession
                    ? get_allbookingcounts.upcommingSession
                    : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(sessionComp)"
          >
            <b-card
              title="Session Completed"
              style="max-width: 40rem"
              class="mb-2 bg-f8f9fa fsize21px shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_allbookingcounts.completedSession
                    ? get_allbookingcounts.completedSession
                    : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
        <!-- <swiper-slide>
          <div class="gray-card cursor-pointer" @click="handleclick(careerReq)">
            <b-card
              title="Career Requirement"
              style="max-width: 20rem"
              class="mb-2 bg-f8f9fa fsize21px"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_allbookingcounts.careerRequirement
                    ? get_allbookingcounts.careerRequirement
                    : 0
                }}</b>
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide> -->
        <swiper-slide>
          <div
            class="gray-card cursor-pointer"
            @click="handleclick(earningTable)"
          >
            <b-card
              title="Total Earning"
              style="max-width: 40rem"
              class="mb-2 bg-f8f9fa fsize21px shadow-md"
            >
              <b-card-text class="fsize21px"
                ><b>{{
                  get_allbookingcounts.totalEarning
                    ? get_allbookingcounts.totalEarning
                    : 0
                }}</b>
                <!-- <b-button class="btn-p20 ml-10" variant="primary"
                  >Withdraw</b-button
                > -->
              </b-card-text>
            </b-card>
          </div>
        </swiper-slide>
      </swiper>
    </b-card>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      volunteerTable: "volunteer-table",
      sessionComp: "session-comp",
      careerReq: "career-req",
      earningTable: "earning-table",
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },
  methods: {
    async handleclick(route) {
      const payload = {
        volunteerId: this.get_volunteerbyuserId[0]._id,
      };
      const payload1 = {
        _id: this.get_volunteerbyuserId[0]._id,
        limit: 10,
        offset: 1,
      };
      try {
        await this.$store.dispatch("respitecare/get_allbookingcounts", payload);
      } catch (error) {}
      this.$router.push({ name: route });
    },
    async function() {
      await this.$store.dispatch("respitecare/get_allbookingcounts", {
        volunteerId: this.get_volunteerbyuserId[0]._id,
      });
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", {
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
    ...mapState("respitecare", {
      get_allbookingcounts: "get_allbookingcounts",
    }),

    ...mapState("respitecare", {
      get_completedbooking: "get_completedbooking",
    }),
    ...mapState("respitecare", {
      get_upcomingbooking: "get_upcomingbooking",
    }),
  },
  mounted() {
    this.function();
  },
};
</script>

<style>
.fsize21px {
  font-size: 21px;
}
.btn-p20 {
  padding: 6px 20px !important;
}
</style>
